import { render, staticRenderFns } from "./WhatsAppBusiness.vue?vue&type=template&id=470922db"
var script = {}
import style0 from "./WhatsAppBusiness.vue?vue&type=style&index=0&id=470922db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports